import React from 'react';
import MessageToAppHandler from '../../../common/message_to_app_handler';

function MessageToApp({
  messageToAppData,
  setMessageToAppData
}) {
  return (
    <MessageToAppHandler
      messageToAppData={ messageToAppData }
      setMessageToAppData={ setMessageToAppData }
    />
  );
}

export default MessageToApp;
